import * as ng from 'angular';

class SmartTableController implements ng.IController {
    static $inject: string[] = [
        '$scope',
        '$timeout'
    ];
    constructor(
        private $scope: any,
        private $timeout: ng.ITimeoutService
    ) {
        let nameList = ['Pierre', 'Pol', 'Jacques', 'Robert', 'Elisa'];
        let familyName = ['Dupont', 'Germain', 'Delcourt', 'bjip', 'Menez'];

        $scope.isLoading = false;
        $scope.rowCollection = [];


        function createRandomItem() {
            let
                firstName = nameList[Math.floor(Math.random() * 4)],
                lastName = familyName[Math.floor(Math.random() * 4)],
                age = Math.floor(Math.random() * 100),
                email = firstName + lastName + '@whatever.com',
                balance = Math.random() * 3000;

            return {
                firstName: firstName,
                lastName: lastName,
                age: age,
                email: email,
                balance: balance
            };
        }

        function getAPage() {
            let data = [];
            for (let j = 0; j < 20; j++) {
                data.push(createRandomItem());
            }
            return data;
        }

        let lastStart = 0;
        let maxNodes = 40;

        $scope.callServer = function getData(tableState: any) {

            // here you could create a query string from tableState
            // fake ajax call
            $scope.isLoading = true;

            $timeout(() => {

                // if we reset (like after a search or an order)
                if (tableState.pagination.start === 0) {
                    $scope.rowCollection = getAPage();
                } else {
                    // we load more
                    $scope.rowCollection = $scope.rowCollection.concat(getAPage());

                    // remove first nodes if needed
                    if (lastStart < tableState.pagination.start && $scope.rowCollection.length > maxNodes) {
                        // remove the first nodes
                        $scope.rowCollection.splice(0, 20);
                    }
                }
                lastStart = tableState.pagination.start;
                $scope.isLoading = false;
            }, 1000);
        };
        $scope.rowCollection = getAPage();
    }
}

export const SmartTableComponent: ng.IComponentOptions = {
    template: require('./smart-table.html'),
    controller: SmartTableController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/smart-table.ts